export function FixedTwoDecimal(number : number) {
  // Convert the number to a string
  let numStr = number.toString()

  // Find the position of the decimal point
  let decimalPos = numStr.indexOf('.')

  // If there is no decimal point, return the number as it is with '.00' appended
  if (decimalPos === -1) {
    return numStr
  }

  // Return the string truncated to two decimal places
  let truncatedNumStr = numStr.slice(0, decimalPos + 3)

  // Ensure there are always two decimal places
  if (truncatedNumStr.length - decimalPos < 3) {
    truncatedNumStr += '0'
  }

  return truncatedNumStr
}

export function FixedFourDecimal(number : number) {
  // Convert the number to a string
  let numStr = number.toString()

  // Find the position of the decimal point
  let decimalPos = numStr.indexOf('.')

  // If there is no decimal point, return the number as it is with '.00' appended
  if (decimalPos === -1) {
    return numStr + '.0000'
  }

  // Return the string truncated to two decimal places
  let truncatedNumStr = numStr.slice(0, decimalPos + 5)

  // Ensure there are always two decimal places
  if (truncatedNumStr.length - decimalPos < 5) {
    truncatedNumStr += '0'
  }

  return truncatedNumStr
}

export function FormatNumberWithDecimal(num: number) {
  return num === 0 ? "0" : num % 1 === 0 ? num.toString() : num.toFixed(2);
}